module.exports = __webpack_public_path__ + "img/37Nixon.87ad4697.png";